import _ from 'lodash'

const isProd = process.env.NODE_ENV === 'production'
const isMock = process.env.REACT_APP_MOCK !== undefined
const serverPort = process.env.REACT_APP_SERVER_PORT || '8000'
const serverApi = process.env.REACT_APP_SERVER_URL || 'draft.allly.co'
const subPrefix = _.chain(serverApi)
  .split('.')
  .head()
  .value()

export const CURRENT_TOWN = 'currentTown'

var langText = null

const getLangText = supportedLanguages => {
  langText = langText
    ? langText
    : supportedLanguages.reduce((prev, lang) => {
        prev[lang] = ''
        return prev
      }, {})
  langText.lang = true
  return langText
}

const config = {
  isProd,
  isMock,
  subPrefix: isProd ? subPrefix : 'dev',
  apiEndpoint: isProd
    ? `https://${serverApi}/api`
    : `http://localhost:${serverPort}/api`,
  imageURLPrefix: isProd
    ? `https://${serverApi}/images`
    : `http://localhost:${serverPort}/images`,
  mainImageURLPrefix: isProd
    ? `https://x.allly.co/tp/backend/image`
    : `http://localhost:8000/main-images`,
  defaultLanguage: 'th',
  supportedLanguages: ['th', 'en', 'zh'],
  getLangText: function() {
    return getLangText(this.supportedLanguages)
  },
  adminTowns: ['glog-provider', 'draft', 'dev', 'agrifair'],
}

export default config



// WEBPACK FOOTER //
// ./src/config.js